import React, { ReactNode } from 'react';

interface DefaultLayoutProps {
  children: ReactNode;
}

const DefaultLayout = ({ children }: DefaultLayoutProps) => {
  return (
    <div style={{ width: '100%', height: '100vh' }}>
      {children}
    </div>
  );
};

export default DefaultLayout;
